import { ColProps } from 'antd';

export interface FilterSectionProps extends Partial<ColProps> {
  label?: React.ReactNode;
  children: React.ReactNode;
}

const FilterSection: React.FC<FilterSectionProps> = () => {
  return null;
};

export default FilterSection;
